// src/shared/components/AssetBadge.jsx
import React from 'react';
import PropTypes from 'prop-types';
import LabelPill from './pill/LabelPill';
import { getIntegrationDisplayName } from '../../integrations';

/**
 * AssetBadge
 * Displays a badge indicating whether an asset is internal or linked to an integration.
 *
 * The integration case is the one label in the app that keeps a colour: an asset synced from a
 * vendor really is a different kind of object from one created here — different source of truth,
 * different rules about what can be edited — and admins scan a list for exactly that.
 */
export default function AssetBadge({ asset, className }) {
  const integrationLabel = asset.integration?.display_name
    || (asset.integration?.type ? getIntegrationDisplayName(asset.integration.type) : null);

  return (
    <LabelPill tone={integrationLabel ? 'info' : 'neutral'} className={className}>
      {integrationLabel || 'Internal'}
    </LabelPill>
  );
}

AssetBadge.propTypes = {
  asset: PropTypes.shape({
    asset_ext_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    integration: PropTypes.shape({
      type: PropTypes.string,
      display_name: PropTypes.string,
    }),
  }).isRequired,
  className: PropTypes.string
};
